var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouseIconAgency(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.03857,
    y: 7.37598,
    width: 31.8613,
    height: 35.4104,
    rx: 2.5,
    fill: "#EEEEEE",
    stroke: "#F46940",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6919,
    y: 15.5684,
    width: 13.6919,
    height: 4,
    fill: "#C0C0C0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6919,
    y: 23.0815,
    width: 13.6919,
    height: 4,
    fill: "#C0C0C0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26.4038,
    y: 23.0815,
    width: 5.84326,
    height: 4,
    fill: "#C0C0C0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 26.4038,
    y: 15.5684,
    width: 5.84326,
    height: 4,
    fill: "#C0C0C0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6919,
    y: 30.5947,
    width: 8.21167,
    height: 4,
    fill: "#C0C0C0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9541,
    y: 30.5947,
    width: 11.2927,
    height: 4,
    fill: "#C0C0C0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3188 3.65742C18.158 4.15241 17.7375 4.55859 17.2171 4.55859H14.8301C14.2778 4.55859 13.8301 5.00631 13.8301 5.55859V9.51392C13.8301 10.0662 14.2778 10.5139 14.8301 10.5139H29.3906C29.9429 10.5139 30.3906 10.0662 30.3906 9.51392V5.55859C30.3906 5.00631 29.9429 4.55859 29.3906 4.55859H27.0036C26.4832 4.55859 26.0627 4.15241 25.9019 3.65742C25.3827 2.05944 23.8814 0.904297 22.1104 0.904297C20.3393 0.904297 18.838 2.05944 18.3188 3.65742ZM22.1104 5.34351C22.7612 5.34351 23.2888 4.81589 23.2888 4.16504C23.2888 3.51419 22.7612 2.98657 22.1104 2.98657C21.4595 2.98657 20.9319 3.51419 20.9319 4.16504C20.9319 4.81589 21.4595 5.34351 22.1104 5.34351Z",
    fill: "#FB8F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseIconAgency);
export default __webpack_public_path__ + "static/media/houseIconAgency.cd4d31c7da9133793831c4e35ecf1327.svg";
export { ForwardRef as ReactComponent };